import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { Source, SourceService } from 'src/app/shared/services/source.service';
import { RegionsService, Region } from 'src/app/shared/services/regions.service';
import { Users, SalesService } from 'src/app/shared/services/sales.service';
import { sectorslist, SectorsService } from 'src/app/shared/services/sectors.service';
import { statuslist, StatusService } from 'src/app/shared/services/status.service';
import { CategoriesService, Categorieslist } from 'src/app/shared/services/categories.service';
import { ProductitemService, ProductItem } from 'src/app/shared/services/productitem.service';
import { CustomerNeedService, CustomerNeed } from 'src/app/shared/services/customer-need.service';
import { CustomerService, Customer } from 'src/app/shared/services/customer.service';
import { UserComment, CommentsService } from 'src/app/shared/services/comments.service';
import { TabViewModule } from 'primeng/tabview';
import { OpportunitiesDTO } from 'src/app/services/opportunitiesPage/opportunities-dto';
import { OpportunitiesService } from '../../../services/opportunitiesPage/opportunities.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DatePipe, formatDate } from '@angular/common';
import { Category, Item, Product, ProductResponse, OrderRow, ProductsService, Type, ProductType } from 'src/app/shared/services/products.service';
import { AttachmentService, FileAttachment } from 'src/app/shared/services/attachment.service';
import { OpportunityorderService } from 'src/app/shared/services/opportunityorder.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api/message';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItemGroup } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { ProspectsService } from 'src/app/shared/services/prospects.service';

import * as $ from 'jquery';
import { SalesRepService } from 'src/app/shared/services/sales-rep.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';




@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.scss']
})
export class LeadsComponent implements OnInit {
  loggedUser: Users;
  angForm: FormGroup;
  myGroup: FormGroup;
  msgs: Message[] = [];  constructor(private messageService: MessageService, private confirmationService: ConfirmationService
    , private location: Location, public datepipe: DatePipe, private fb: FormBuilder, private route: ActivatedRoute,
    private router: Router, private opportunityorderService: OpportunityorderService, private attachmentsService: AttachmentService, private productsService: ProductsService, private opportunitiesService: OpportunitiesService, private commentsService: CommentsService, private customerService: CustomerService, private customerNeedService: CustomerNeedService, private categoriesService: CategoriesService, private itemService: ProductitemService, private statusService: StatusService, private sourceService: SourceService, private regionService: RegionsService,
    private salesService: SalesService, private sectorService: SectorsService, private salesRepservice: SalesRepService,
    private prospectsService: ProspectsService, private ref: ChangeDetectorRef, public authenticationService: AuthenticationService ) {
    this.createForm();
      // Get state data from router navigation if available
    const navigation = this.router.getCurrentNavigation();
    this.prospectData = navigation?.extras?.state;
    if (this.prospectData) {
      console.log("Prospect data received in constructor:", this.prospectData);
    }
  }


  createForm() {

    this.myGroup = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      oppName: new FormControl('', [Validators.required]),
      customerNumber: new FormControl(null, [Validators.required]),
      sssOwnerName: new FormControl(null, [Validators.required]),
      sector: new FormControl(null, [Validators.required]),
      region: new FormControl(null, [Validators.required]),
      status: new FormControl(null, [Validators.required]),
      customerNeed: new FormControl(null, [Validators.required]),
      expectedClosingDate: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.required]),
      partenerName: new FormControl(null, [Validators.nullValidator]),
      salesRep: new FormControl('select'),
      techLead: new FormControl('select'),
      //email: new FormControl('', [Validators.required, Validators.email]),
      //body: new FormControl('', Validators.required)
      //userInfoUserName: new FormControl({ value: '' }, Validators.compose([Validators.required])),
      // userInfoName: new FormControl({ value: '' }, Validators.compose([Validators.required])),
      //userInfoSurName: new FormControl({ value: '' }, Validators.compose([Validators.required]))

    });

  }

  @ViewChild("swNewLicense", { static: true }) swLicense: ElementRef;
  @ViewChild("swReinstLicense", { static: true }) swReinstLicense: ElementRef;
  @ViewChild("swRenewLicense", { static: true }) swRenewLicense: ElementRef;
  @ViewChild("opportunityTypeEle", { static: true }) opportunityTypeEle: ElementRef;
  @ViewChild("opportunityTypeEle", { static: true }) serviceDetailsEle: ElementRef;
  @ViewChild("gmsrNewLicense", { static: true }) gmsrNewLicense: ElementRef;
  @ViewChild("vadNewLicense", { static: true }) vadNewLicense: ElementRef;
  @ViewChild("swAppNewLicense", { static: true }) swAppNewLicense: ElementRef;
  @ViewChild("zswNewLicense", { static: true }) zswNewLicense: ElementRef;
  @ViewChild("saasswNewLicense", { static: true }) saasswNewLicense: ElementRef;
  @ViewChild("redhatSwNewLicense", { static: true }) redhatSwNewLicense: ElementRef;

  @ViewChild("swReinstGmsrNewLicense", { static: true }) swReinstGmsrNewLicense: ElementRef;
  @ViewChild("swReinstVADNewLicense", { static: true }) swReinstVADNewLicense: ElementRef;
  @ViewChild("swReinstAppNewLicense", { static: true }) swReinstAppNewLicense: ElementRef;
  @ViewChild("swReinstZNewLicense", { static: true }) swReinstZNewLicense: ElementRef;
  @ViewChild("swReinstsaasNewLicense", { static: true }) swReinstsaasNewLicense: ElementRef;
  @ViewChild("swRenewGMSRLicense", { static: true }) swRenewGMSRLicense: ElementRef;
  @ViewChild("swRenewVADLicense", { static: true }) swRenewVADLicense: ElementRef;
  @ViewChild("swRenewAppLicense", { static: true }) swRenewAppLicense: ElementRef;
  @ViewChild("swRenewZLicense", { static: true }) swRenewZLicense: ElementRef;
  @ViewChild("swRenewSAASLicense", { static: true }) swRenewSAASLicense: ElementRef;
  @ViewChild("swRenewRedhat", { static: true }) swRenewRedhat: ElementRef;
  @ViewChild("swgServiceLicense", { static: true }) swgServiceLicense: ElementRef;
  @ViewChild("swgServiceTotalBrandsLicense", { static: true }) swgServiceTotalBrandsLicense: ElementRef;

  // For STG Tab
  @ViewChild("stgOpportunityTypeEle", { static: true }) stgOpportunityTypeEle: ElementRef;
  @ViewChild("stgServiceDetails", { static: true }) stgServiceDetails: ElementRef;
  @ViewChild("stgHardwareDetails", { static: true }) stgHardwareDetails: ElementRef;

  @ViewChild('bussPartner', { static: true }) bussPartnerInput: HTMLInputElement;
  //@ViewChild("fileUpload", { static: true }) fileUpload: ElementRef;


  public serviceProductType: ProductType = {
    productType: 'service',
    typeId: 0 ,
    reorderLevel: 0,
    reorderAvailable: 0
  }

  public opportunitiesDTO: OpportunitiesDTO = new OpportunitiesDTO();
  public items: ProductItem[];
  public statusList: statuslist[];
  public userLoginName: string;
  createdDate: string;
  public regionsList: Region[];
  public errorMsg;
  displayPartnerName: boolean = false;
  licenseAndServiceOnly: boolean = false;
  serviceOnly: boolean = false;
  licenseOnly: boolean = false;
  stglicenseAndServiceOnly: boolean = false;
  stgserviceOnly: boolean = false;
  stglicenseOnly: boolean = false;

  public salesUsers: Users[];
  public categorieslist: Categorieslist[];
  public customerNeedList: CustomerNeed[];
  public customerList: Customer[];
  public userCommentsList: UserComment[] = [];
  public productList: Product[];
  attachmentFiles: FileAttachment[] = [];
  public orderList = [];
  editOpportunityId = -1;
  canEdit: boolean;
  hasSWG: boolean;
  hasSTG: boolean;
  public salesReps: any[];

  public techLeads: Users[];

  // Property to hold navigation state from prospect page
  private prospectData: any;
  async ngOnInit() {
    // this.productsService.getProductsRows().then(data => this.products = data);
    // Spinner
    $("body").css("overflow-y", "hidden");
    await this.loadLists();

    this.route
      .queryParams
      .subscribe(params => {
        // console.log("params coming from previous page.............");
        ////console.log(params);
        // Defaults to -1 if no query param provided.
        this.editOpportunityId = +params['id'] || -1;
      });
    ////console.log("this.editOpportunityId : " + this.route.snapshot.paramMap.get('id'));
    // console.log("this.editOpportunityId : " + this.editOpportunityId);

    if (this.editOpportunityId != -1) {
      await this.opportunitiesService.hasEditOpportunityPermission().toPromise().then(response => { this.canEdit = response; });

      if (!this.canEdit) {
        this.location.back();
      }
      await this.opportunitiesService.retrieveOpportunity(this.editOpportunityId).toPromise().then(
        response => {
          ////console.log("retrieve Opportunity : "+ response);
          // console.log(response);
          let opportunities = response;
          this.opportunitiesDTO = opportunities[0];
          this.userLoginName = this.opportunitiesDTO.users.firstName + " " + this.opportunitiesDTO.users.lastName;
          this.myGroup.controls.name.setValue(this.opportunitiesDTO.opportunitySource.sourceId);
          this.myGroup.controls.oppName.setValue(this.opportunitiesDTO.opportunityName);


         this.myGroup.controls.customerNumber.setValue(this.opportunitiesDTO.customer.customerId);
          this.myGroup.controls.sssOwnerName.setValue(this.salesUsers.find(sales => (sales.firstName) + ' ' + (sales.lastName) == this.opportunitiesDTO.sssOwnerName));
          this.myGroup.controls.sector.setValue(this.opportunitiesDTO.sector.sectorId);
          this.myGroup.controls.region.setValue(this.opportunitiesDTO.region.regionId);
          this.myGroup.controls.status.setValue(this.opportunitiesDTO.status.statusId);
          this.myGroup.controls.customerNeed.setValue(this.opportunitiesDTO.customerNeed.customerId);
          this.myGroup.controls.partenerName.setValue(this.opportunitiesDTO.partenerName);
          this.myGroup.controls.salesRep.setValue(this.salesReps.find(sales => sales.value == this.opportunitiesDTO.salesRep?.name).name);
          // in case no tech lead selected
          this.myGroup.controls.techLead.setValue(
            this.opportunitiesDTO.techLead ?
              this.techLeads.find(techLead => techLead.userId === this.opportunitiesDTO.techLead.userId) :
              null
          );
          var select = <HTMLSelectElement>document.getElementById('status');
          var input = <HTMLInputElement>document.getElementById("odds");
          input.value = select.options[select.selectedIndex].id;

          if (this.opportunitiesDTO.opportunitySource.sourceId == 1) {
            this.displayPartnerName = true;
            // console.log("this.opportunitiesDTO.partenerName: " + this.opportunitiesDTO.partenerName);
          }
        },
        error => this.errorMsg = error
      );

      await this.opportunityorderService.retrieveOpportunityOrders(this.editOpportunityId).toPromise().then(
        response => {
          ////console.log("retrieve Opportunity Orders: "+ response);
          ////console.log(response);
          debugger
          this.orderList = response;
          this.products = []; // Initialize the products array here

          if (this.orderList && this.orderList.length > 0) {
            let index = -1;

            this.serviceOrdersCount = 0;
            this.licenseOrdersCount = 0;

            this.orderList.forEach(order => {
              index++;
              const productRow: OrderRow = {
                rowIndex: index,
                category: order.opportunityProduct?.productCategory,
                productType: order.opportunityProduct?.productType,
                item: order.opportunityProduct?.productItem,
                productId: order.opportunityProduct?.productId,
                productKind: order.opportunityProduct?.productKind,
                orderId: order.orderId,
                orderPrice: parseInt(order.orderPrice)
              };



              // if not service
              if (productRow.productType == null) {
                productRow.productType = this.serviceProductType;
                this.serviceOrdersCount++;
              } else {
                this.licenseOrdersCount++;
              }

              this.products.push(productRow);
              // }

            });
          }

          this.orderPopulated = false;
        },
        error => this.errorMsg = error
      );




      await this.attachmentsService.getAttachments(this.editOpportunityId).toPromise().then(
        response => {
          //////console.log("retrieve Attachment Response : "+ response);
          //////console.log(response);
          this.attachmentFiles = response;
        },
        error => this.errorMsg = error
      );

      await this.commentsService.getUserComments(this.editOpportunityId).toPromise().then(
        response => {
          //////console.log("getAllUserComments : "+ response);
          //////console.log(response);
          this.userCommentsList = response;
        },
        error => this.errorMsg = error
      );    }    else {
      //////console.log("this.editOpportunityId is null");
      // Note: Prospect data handling is now done in applyProspectData() after lists are loaded
    }

    let date = new Date();


    (async () => {
      // Do something before delay

      await this.delay(1500);
//      this.getCustomerList();

      if (this.editOpportunityId == -1) {

        this.createdDate = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
        this.opportunitiesDTO.createdDate = this.createdDate;
        this.opportunitiesDTO.users = { userId: this.loggedUser.userId, firstName: this.loggedUser.firstName, lastName: this.loggedUser.lastName };
      }
      else {
        date = new Date(this.opportunitiesDTO.createdDate);

        //date = this.datepipe.transform(this.opportunitiesDTO.createdDate, "yyyy-MM-dd'T'HH:mm:ss.SSSZ");
        //date = this.opportunitiesDTO.createdDate;
        this.createdDate = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();

        date = new Date(this.formatDate(this.opportunitiesDTO.expectedClosingDate));
        this.opportunitiesDTO.expectedClosingDate = date;//date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

        if (this.opportunitiesDTO.dueDate != null) {
          date = new Date(this.formatDate(this.opportunitiesDTO.customerTiming));
          this.opportunitiesDTO.customerTiming = date;//.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        }
        if (this.opportunitiesDTO.dueDate != null) {
          date = new Date(this.formatDate(this.opportunitiesDTO.dueDate));
          this.opportunitiesDTO.dueDate = date;//date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        }

        var sbmchannel = <HTMLSelectElement>document.getElementById('sbmchannel');
        //var salesRep =  <HTMLSelectElement>document.getElementById('salesRep');
        let options = sbmchannel.options;
        for (let index = 0; index < options.length; index++) {
          const element = options[index];
          // //////console.log(element);
          //////console.log(this.opportunitiesDTO.sbmchannel);
          //////console.log(element.value);
          if (element.value == this.opportunitiesDTO.sbmchannel) {
            element.selected = true;
          }

        }
        /*options = salesRep.options;
        for (let index = 0; index < options.length; index++) {
          const element = options[index];
          if (element.value== this.opportunitiesDTO.salesRep){
            element.selected = true;
          }
        }*/

      }

      await this.opportunitiesService.hasSWGOpportunityPermission().toPromise().then(response => { this.hasSWG = response; });
      await this.opportunitiesService.hasSTGOpportunityPermission().toPromise().then(response => { this.hasSTG = response; });

      // Spinner
      $(".spinner-container").fadeOut();
      $("body").css("overflow-y", "auto");
    })();
    $('#companyInfo').trigger('click');

  }

  swgoptionValues = [];
  stgoptionValues = [];


  populateOrders() {
    debugger;
    for (var l = 0; l < this.orderList.length; l++) {
      //////console.log("line number 283 @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
      var currentOrder = this.orderList[l];
      var orderPrice = currentOrder.orderPrice;
      //////console.log(currentOrder);
      // to add comma in price.
      orderPrice = orderPrice.toString();

      var orderCateory = currentOrder.opportunityProduct.productCategory.category;
      //////console.log("orderCateory: "+ orderCateory);

      var opportunityProduct1 = currentOrder.opportunityProduct;
      //////////console.log(opportunityProduct1);
      var orderItem = '';
      var orderType = '';

      if (currentOrder.opportunityProduct.productType !== null)
        orderType = currentOrder.opportunityProduct.productType.productType;

      if (currentOrder.opportunityProduct.productItem !== null)
        orderItem = currentOrder.opportunityProduct.productItem.item;

      //////console.log("orderType: "+ orderType);
      //////console.log("orderItem: "+ orderItem);
      ////console.log("orderPrice: "+ orderPrice);

      if (opportunityProduct1.productKind === "SWG") {
        if (l == 0) {
          this.swgoptionValues.push(orderCateory);
        }
        else {
          this.swgoptionValues[0] = (this.swgoptionValues[0] + "~" + orderCateory);
        }
      }
      if (opportunityProduct1.productKind === "STG") {
        if (l == 0) {
          this.stgoptionValues.push(orderCateory);
        }
        else {
          this.stgoptionValues[0] = (this.stgoptionValues[0] + "~" + orderCateory);
        }
      }
      ////console.log("line 322 @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");

      if (opportunityProduct1.productKind === "SWG") {

        if (orderCateory === 'Service' && orderType == "") {
          orderType = "@@@";
          $('#swgServiceAssetName').val(currentOrder.swgServiceAssetName);
          $('#swgServiceAssetVersion').val(currentOrder.swgServiceAssetVersion);
          $('#swgServiceAssetId').val(currentOrder.swgServiceAssetId);
          $('#swgServiceAssetIncluded').prop("checked", currentOrder.swgServiceAssetIncluded);
        }
        else {
          orderCateory = orderCateory.replace(" ", "~");
        }
        var computedId = orderCateory + "-" + orderType + "-" + orderItem;
        ////console.log(computedId);
        var elements = document.getElementsByClassName(computedId);
        ////console.log(elements);
        ////console.log(elements.length);
        for (let index = 0; index < elements.length; index++) {
          const element = <HTMLInputElement>elements[index];
          ////console.log(element);
          element.value = orderPrice;

        }
      }
      else if (opportunityProduct1.productKind === "STG") {

        var elements = document.getElementsByClassName(orderItem);
        ////console.log(elements);
        ////console.log(elements.length);
        for (let index = 0; index < elements.length; index++) {
          const element = <HTMLInputElement>elements[index];
          ////console.log(element);
          element.value = orderPrice;

        }
      }


      this.calulateTotals();
    }
    ////console.log(this.swgoptionValues);
  }
  ////////zzzzzxxxx
  sectors: sectorslist[];
  sourceList: Source[] = [];

  async loadLists() {



    await this.sourceService.getSourceList().toPromise().then(
      response => {
        //////console.log("retrieveSourceList : "+ response);
        //////console.log(response);
        this.sourceList = response;

      }
    );

    await this.productsService.getProducts().toPromise().then(
      response => {
        //////console.log("getAllRegions : "+ response);
        ////////console.log(response);
        this.productList = response;
      },
      error => this.errorMsg = error
    );

    await this.regionService.getRegionsByUser().toPromise().then(
      response => {
        //////console.log("getAllRegions : "+ response);
        ////////console.log(response);
        this.regionsList = response;
      },
      error => this.errorMsg = error
    );

    await this.sectorService.getsectorsList().toPromise().then(
      response => {
        //////console.log("retrieveSectors : "+ response);
        //////console.log(response);
        this.sectors = response;
      },
      error => this.errorMsg = error
    );

    await this.salesService.retrieveMainData().toPromise().then(
      response => {
        //////console.log("getAllUsersMainData : "+ response);
        //////console.log(response);
        this.salesUsers = response;

        this.salesUsers.forEach((data, index) => {
          let user = <Users>data;
          if (user.email.toLowerCase() == sessionStorage.getItem('loginUserName').toLowerCase()) {
            this.userLoginName = user.firstName + " " + user.lastName;
            this.loggedUser = user;
          }
        });

      },
      error => this.errorMsg = error
    );

    await this.salesService.retrieveTechLeads().toPromise().then(response => { this.techLeads = response; });
    await this.statusService.getstatusList().toPromise().then(
      response => {
        //////console.log("getAllStatus : "+ response);
        ////////console.log(response);
        this.statusList = response;
      },
      error => this.errorMsg = error
    );

    await this.categoriesService.getCategoriesList().toPromise().then(
      response => {
        //////console.log("getCategories : "+ response);
        ////////console.log(response);
        this.categorieslist = response;
      },
      error => this.errorMsg = error
    );


    await this.itemService.getProductItems().toPromise().then(
      response => {
        //////console.log("getAllProductItems : "+ response);
        //////console.log(response);
        this.items = response;
      },
      error => this.errorMsg = error
    );

    await this.customerNeedService.getAllCustomerNeeds().toPromise().then(
      response => {
        //////console.log("getAllCustomerNeeds : "+ response);
        //////console.log(response);
        this.customerNeedList = response;
      },
      error => this.errorMsg = error
    );    await this.salesRepservice.getSalesRep().toPromise().then(
      response => {

        this.salesReps = response;
        // console.log("salesRep" + this.salesReps)
      },
      error => this.errorMsg = error
    );

    await this.getCustomerList();

    // Apply prospect data after all lists are loaded
    if (this.prospectData) {
      this.applyProspectData();
    }


  }


  // make customer lazy load



  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  Comma(event: any) { //function to add commas to textboxes
    //////console.log(event);
    var Num = event.target.value;
    // console.log(Num);
    if (Num.indexOf(0) == 0) {
      Num = parseInt(Num);
    }
    // console.log(Num);
    Num += '';
    Num = Num.replace(',', '');
    Num = Num.replace(',', '');
    Num = Num.replace(',', '');
    Num = Num.replace(',', '');
    Num = Num.replace(',', '');
    Num = Num.replace(',', '');
    // console.log(Num);
    var x = Num.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1))
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    //////console.log(x1 + x2);

    event.target.value = x1 + x2;
  }


  async getCustomerList(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        let regionArr = [];
        let sectorArr = [];

        for (let index = 0; index < this.regionsList.length; index++) {
          const region = this.regionsList[index];
          regionArr.push(region.regionId);
        }

        this.sectors.forEach(element => {
          let sector = <sectorslist>element;
          sectorArr.push(sector.sectorId);
        });

        const postData = { "region": regionArr, "sector": sectorArr };

        await this.customerService.retriveCustomersByRegionAndSector(postData).toPromise().then(
          response => {
            //////console.log("getCustomerList : "+ response);
            //////console.log(response);
            this.customerList = response;
            this.ref.detectChanges();
            resolve();
          },
          error => {
            this.errorMsg = error;
            reject(error);
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }


  public onDropDownChange(obj: any) {
    ////console.log(obj);
    ////console.log(obj.target.name);
    ////console.log(obj.target.value);
    //////console.log(obj.target);

    if (obj.target.name != undefined) {

      var select = <HTMLSelectElement>document.getElementById('status');

      var input = <HTMLInputElement>document.getElementById("odds");

      ////console.log(select.selectedIndex);
      ////console.log(select.options[select.selectedIndex]);
      ////console.log(select.options[select.selectedIndex].id);
      if (obj.target.name == 'status') {
        input.value = select.options[select.selectedIndex].id;
      }


      if (obj.target.value == "1") {
        this.displayPartnerName = true;
      }
      else {
        this.displayPartnerName = false;
      }
      if (obj.target.name == 'sbmchannel') {
        this.opportunitiesDTO.sbmchannel = obj.target.value;
      }

    }


  }

  onInputChange(event: any) {
    ////console.log(event);
    ////console.log(event.target);
    ////console.log(event.target.id);

    if (event.target.id == 'opportunityName') {
      this.opportunitiesDTO.opportunityName = event.target.value;
    }
  }

  licenseDataCollapsed = true;
  serviceDataCollapsed = true;
  stgHardwareDataCollapsed = true;
  stgServiceDataCollapsed = true;

  public onSTGOpportunitySelect(event: any) {

    if (event.target.id == "collapse2-1") {
      this.stglicenseAndServiceOnly = true;
      this.stgserviceOnly = false;
      this.stglicenseOnly = false;

      if (this.stgHardwareDataCollapsed) {
        //this.toggleSTGHardwareData();
        this.stgHardwareDataCollapsed = false;
      }

      if (this.stgServiceDataCollapsed) {
        //this.toggleSTGServiceData();
        this.stgServiceDataCollapsed = false;
      }
    }
    else if (event.target.id == "collapse2-3") {
      this.stglicenseAndServiceOnly = false;
      this.stgserviceOnly = true;
      this.stglicenseOnly = false;

      if (this.stgServiceDataCollapsed) {
        //this.toggleSTGServiceData();
        this.stgServiceDataCollapsed = false;
      }

    }
    else if (event.target.id == "collapse2-2") {
      this.stglicenseAndServiceOnly = false;
      this.stgserviceOnly = false;
      this.stglicenseOnly = true;
      //this.toggleLicenseData();

      if (this.stgHardwareDataCollapsed) {
        //this.toggleSTGHardwareData();
        this.stgHardwareDataCollapsed = false;
      }
    }

    if (this.stgOpportunityTypeEle != undefined) {
      this.stgOpportunityTypeEle.nativeElement.click();
    }

  }

  toggleSTGServiceData() {

    if (this.stgServiceDetails != undefined) {
      this.stgServiceDetails.nativeElement.click();
    }
  }

  toggleSTGHardwareData() {

    if (this.stgHardwareDetails != undefined) {
      this.stgHardwareDetails.nativeElement.click();
    }
  }
  public onOpportunitySelect(event: any) {
    //////console.log(event);
    ////console.log(event.target.id);
    ////console.log(this.swLicense);
    ////console.log(this.swReinstLicense);
    ////console.log(this.swRenewLicense);

    ////console.log(this.opportunityTypeEle);


    if (event.target.id == "collapseOne") {
      this.licenseAndServiceOnly = true;
      this.serviceOnly = false;
      this.licenseOnly = false;

      //this.toggleLicenseData();
      //this.toggleServiceData();

      if (this.licenseDataCollapsed) {
        //this.toggleLicenseData();
        this.licenseDataCollapsed = false;
      }

      if (this.serviceDataCollapsed) {
        //this.toggleServiceData();
        this.serviceDataCollapsed = false;
      }
    }
    else if (event.target.id == "collapseTwo") {
      this.licenseAndServiceOnly = false;
      this.serviceOnly = true;
      this.licenseOnly = false;

      if (this.serviceDataCollapsed) {
        //this.toggleServiceData();
        this.serviceDataCollapsed = false;
      }

    }
    else if (event.target.id == "collapseThree") {
      this.licenseAndServiceOnly = false;
      this.serviceOnly = false;
      this.licenseOnly = true;

      if (this.licenseDataCollapsed) {
        //this.toggleLicenseData();
        this.licenseDataCollapsed = false;
      }
    }

    if (this.opportunityTypeEle != undefined) {
      this.opportunityTypeEle.nativeElement.click();
    }
  }

  toggleLicenseData() {

    if (this.swLicense != undefined) {
      this.swLicense.nativeElement.click();
      this.gmsrNewLicense.nativeElement.click();
      this.vadNewLicense.nativeElement.click();
      this.swAppNewLicense.nativeElement.click();
      this.zswNewLicense.nativeElement.click();
      this.saasswNewLicense.nativeElement.click();
      this.redhatSwNewLicense.nativeElement.click();
    }
    if (this.swReinstLicense != undefined) {
      this.swReinstLicense.nativeElement.click();
      this.swReinstGmsrNewLicense.nativeElement.click();
      this.swReinstVADNewLicense.nativeElement.click();
      this.swReinstAppNewLicense.nativeElement.click();
      this.swReinstZNewLicense.nativeElement.click();
      this.swReinstsaasNewLicense.nativeElement.click();
    }
    if (this.swRenewLicense != undefined) {
      this.swRenewLicense.nativeElement.click();
      this.swRenewGMSRLicense.nativeElement.click();
      this.swRenewVADLicense.nativeElement.click();
      this.swRenewAppLicense.nativeElement.click();
      this.swRenewZLicense.nativeElement.click();
      this.swRenewSAASLicense.nativeElement.click();
      this.swRenewRedhat.nativeElement.click();
    }
  }

  toggleServiceData() {

    if (this.swgServiceLicense != undefined) {
      this.swgServiceLicense.nativeElement.click();
      this.swgServiceTotalBrandsLicense.nativeElement.click();
    }
  }


  public onOppyClick(obj: any) {
    //////console.log(obj);
  }

  onSubmit(event) {
    $(".spinner-container").fadeIn();
    $("body").css("overflow-y", "hidden");

    debugger;
    for (let controller in this.myGroup.controls) {
      this.myGroup.get(controller).markAsTouched();
    }

    // console.log("event " + event);
    // console.log(event.submitter.id);

    if (event.submitter.id == "finish") {
      if (this.myGroup.valid) {
        // console.log('Ok')


        var inputs, index;

        inputs = document.getElementsByTagName('select');
        for (index = 0; index < inputs.length; ++index) {
          // deal with inputs[index] element.
          var id = inputs[index].id;
          var e = (document.getElementById(inputs[index].id)) as HTMLSelectElement;
          ////console.log(e);

          var sel = e.selectedIndex;
          var opt = e.options[sel];
          ////console.log(opt);

          var CurValue;
          var CurText;
          let CurId;

          if (opt != undefined) {
            CurValue = (<HTMLOptionElement>opt).value;
            CurText = (<HTMLOptionElement>opt).text;
            CurId = parseInt((<HTMLOptionElement>opt).id);
          }


          /* ////console.log("starting......................");
            ////console.log(sel);
            ////console.log(CurValue);
            ////console.log(CurText);
            ////console.log(CurId);
            */

          if (id === 'opportunitySource')
            this.opportunitiesDTO.opportunitySource = { sourceId: CurId };

          // console.log("source is :" + this.opportunitiesDTO.opportunitySource);
          // console.log("source is :" + this.opportunitiesDTO.opportunitySource.sourceId);

          let bussPrtnrValue = this.bussPartnerInput.value;

          if (this.opportunitiesDTO.opportunitySource.sourceId == 1) {
            // console.log("bussPrtnrValue is :" + this.opportunitiesDTO.businessPartners);
            if (this.opportunitiesDTO.businessPartners == "") {
              // console.log("source is partner but buss partners is empty");
              this.index = 0;
              this.showMsg('warning', 'Rejected', 'Business Partners Required!!!', 4000);

              $(".spinner-container").fadeOut();
              $("body").css("overflow-y", "auto");
              return;
            }
            if (this.opportunitiesDTO.partenerName == "") {
              // console.log("source is partner but buss partners is empty");
              this.index = 0;
              this.showMsg('warning', 'Rejected', "Partner Name Required!!!", 4000);

              $(".spinner-container").fadeOut();
              $("body").css("overflow-y", "auto");
              return;
            }
          }

          if (id === 'sector')
            this.opportunitiesDTO.sector = { sectorId: CurId };
          if (id === 'region')
            this.opportunitiesDTO.region = { regionId: CurId };
          if (id === 'customerNeed')
            this.opportunitiesDTO.customerNeed = { customerId: CurId };
          if (id === 'customerNumber')
            this.opportunitiesDTO.customer = { customerId: CurId };
          if (id === 'status') {
            this.opportunitiesDTO.status = { statusId: parseInt(CurValue) };
            // if(this.opportunitiesDTO.status.statusId == 5 && this.attachmentFiles.length==0){//Won status-> force add attachment
            //   this.showMsg('warning', 'Rejected', 'Please add the related attachments before close the opportunity', 4000);
            //   return;

            // }
          }

        }

        let salesRepValue = document.getElementById("salesRep").textContent;
        if (salesRepValue.toUpperCase().indexOf('SELECT') === -1) {
          this.opportunitiesDTO.salesRep = salesRepValue;
        } else {
          this.opportunitiesDTO.salesRep = '';
        }

        this.opportunitiesDTO.sssOwnerName = document.getElementById("sssOwnerName").textContent;

        // const selectedTechLeadId = this.myGroup.controls.techLead.value;

        // debugger;
        // console.log("controls.techLead,"+this.myGroup.controls.techLead)
        // console.log("getElementById,"+document.getElementById("techLead"))
        // if (selectedTechLeadId) {
        //   const selectedTechLead = this.techLeads.find(techLead => techLead.userId == selectedTechLeadId);
        //   this.opportunitiesDTO.techLead = selectedTechLead;
        // } else {
        //   // Handle the case when nothing is selected
        //   this.opportunitiesDTO.techLead = null;
        // }
        let date = new Date();
        this.opportunitiesDTO.createdDate = this.datepipe.transform(date, "yyyy-MM-dd'T'HH:mm:ss.SSSZ");




        this.submitData();

      } else {
        // console.log('No');
        this.index = 0;
      }
    }
    else {// post button is clicked

      var commentTitle = <HTMLSelectElement>document.getElementById('commentTitle');
      var commentText = <HTMLSelectElement>document.getElementById('commentText');

      let date = new Date();
      let creatDate = this.datepipe.transform(date, "yyyy-MM-dd'T'HH:mm:ss.SSSZ");

      const userComment: UserComment = {
        commentId: -1,
        title: commentTitle.value,
        text: commentText.value,
        email: "",
        purchaseDatee: creatDate,
        opportunity: { opportunityId: '' },
        user: this.loggedUser
      };

      if (commentText.value != "" && commentTitle.value != "") {
        this.userCommentsList.push(userComment);
        commentText.value = "";
        commentTitle.value = "";
      }
      ////console.log(this.userCommentsList);
      $(".spinner-container").fadeOut();
      $("body").css("overflow-y", "auto");
      return;
    }

    $(".spinner-container").fadeOut();
    $("body").css("overflow-y", "auto");

  }



  public onSubmitClicked(event: any) {

    var inputs, index;
    ////console.log("submit button clicked .......................");


    ////console.log(this.myGroup.value);

  }
  formatDate(date: Date): string {
    let format = formatDate(date, 'yyyy-MM-dd', 'en-US');

    return format;
  }
  submitData() {
    ////console.log("submitData called.............");
    ////console.log(this.opportunitiesDTO);

    // let opportunityId =  1;

    if (this.editOpportunityId != -1) {
      //update opportunity and persist to DB
      this.opportunitiesService.updateOpportunity(this.opportunitiesDTO).subscribe(
        async response => {
          ////console.log("update Opportunity : "+ response);
          ////console.log(response);
          let opportunityId = response.data.opportunityId;

          this.convertToOrderListFromOrdersRows()
          await this.updateOrderPrice(this.editOpportunityId);
          await this.addAttachments(opportunityId);
          await this.addComments(opportunityId);

          this.router.navigate(['/opportunities']);
        },
        error => {
          this.errorMsg = error;
        }
      );
    }    else {
      //create opportunity and persist to DB
      this.opportunitiesService.addOpportunity(this.opportunitiesDTO).subscribe(
        async response => {
          console.log("Create Opportunity Response:", JSON.stringify(response, null, 2));

          // Extract the opportunity ID properly from the response
          let opportunityId;
          if (response && response.data && response.data.opportunityId) {
            opportunityId = response.data.opportunityId;
            // Ensure opportunityId is a number
            if (typeof opportunityId === 'string') {
              opportunityId = parseInt(opportunityId, 10);
            }
            console.log("Extracted opportunity ID:", opportunityId);
          } else {
            console.error("Failed to extract opportunity ID from response:", response);
            this.showMsg('error', 'Error', 'Could not retrieve opportunity ID from server response', 5000);
            this.router.navigate(['/opportunities']);
            return;
          }

          this.convertToOrderListFromOrdersRows()
          await this.addOrderPrice(opportunityId);
          await this.addAttachments(opportunityId);
          await this.addComments(opportunityId);          // Link the opportunity back to the prospect if we came from prospect page
          if (this.prospectData && this.prospectData.prospectId) {
            try {
              // Validate opportunity ID before attempting to link
              if (!opportunityId || isNaN(opportunityId) || opportunityId <= 0) {
                console.error('Invalid opportunity ID:', opportunityId);
                this.showMsg('error', 'Error', 'Cannot link to prospect: Invalid opportunity ID', 5000);
                this.router.navigate(['/opportunities']);
                return;
              }

              // Log the ID types for debugging
              console.log(`Linking opportunity ID: ${opportunityId} (type: ${typeof opportunityId})`);
              console.log(`to prospect ID: ${this.prospectData.prospectId} (type: ${typeof this.prospectData.prospectId})`);

              // Ensure both IDs are numbers
              const numericOpportunityId = Number(opportunityId);
              const numericProspectId = Number(this.prospectData.prospectId);

              if (isNaN(numericProspectId)) {
                console.error('Invalid prospect ID:', this.prospectData.prospectId);
                this.showMsg('error', 'Error', 'Cannot link to prospect: Invalid prospect ID', 5000);
                this.router.navigate(['/opportunities']);
                return;
              }

              console.log(`Linking opportunity ID ${numericOpportunityId} to prospect ID ${numericProspectId}`);
              this.prospectsService.setOpportunityToProspect(numericProspectId, numericOpportunityId)
                .subscribe(response => {                    console.log('Successfully linked opportunity to prospect:', response);
                    this.showMsg('success', 'Success', 'Opportunity was linked to the prospect successfully', 3000);
                    // Navigate back to prospects page since the user came from there
                    this.router.navigate(['/prospects']);
                  },
                  error => {
                    console.error('Error linking opportunity to prospect:', error);

                    // Extract detailed error message
                    let errorMsg = 'Failed to link opportunity to prospect';

                    if (typeof error === 'string') {
                      errorMsg = error;
                    } else if (error.error) {
                      errorMsg = typeof error.error === 'string' ? error.error : JSON.stringify(error.error);
                    }                    // Check if it's a "not found" error
                    const isNotFoundError = errorMsg.toLowerCase().includes('not found');

                    // Show more specific message with longer duration for not found errors
                    if (isNotFoundError) {
                      this.showMsg(
                        'error',
                        'Linking Error',
                        `${errorMsg}. The opportunity was created but could not be linked to the prospect.`,
                        6000
                      );
                    } else {
                      this.showMsg('error', 'Error', errorMsg, 5000);
                    }

                    // Navigate back to prospects page even if linking fails
                    this.router.navigate(['/prospects']);
                  },                  () => {
                    // Complete callback - navigate back to prospects since user came from there
                    this.router.navigate(['/prospects']);
                  }
                );            } catch (error) {
              console.error('Error linking opportunity to prospect:', error);
              // Navigate back to prospects page even if there's an exception
              this.router.navigate(['/prospects']);
            }          } else {
            console.log('No prospect data to link with the opportunity');
            // No prospect data, navigate to regular opportunities page
            this.router.navigate(['/opportunities']);
          }
        },
        error => {
          //this.errorMsg = error;
        }
      );
    }

  }

  updateOrderPrice(oppId) {

    //save order to DB
    for (var i = 0; i < this.orderList.length; i++) {
      let order = this.orderList[i];
      //console.log(order);
      order.opportunity.opportunityId = oppId;

      if (order.orderId == "0") {

        this.opportunityorderService.postOpportunityOrder(order).subscribe(
          response => {
            ////console.log("Create Opportunity : "+ response);
            ////console.log(response);
          },
          error => this.errorMsg = error
        );
      }
      else {
        this.opportunityorderService.updateOpportunityOrder(order).subscribe(
          response => {
            ////console.log("updateOpportunityOrder  : "+ response);
            ////console.log(response);
          },
          error => this.errorMsg = error
        );

      }

    }


  }
  addOrderPrice(oppId) {
    console.log(`Adding order prices for opportunity ID: ${oppId} (${typeof oppId})`);

    // Ensure we have a valid opportunity ID
    if (!oppId || isNaN(Number(oppId)) || Number(oppId) <= 0) {
      console.error('Invalid opportunity ID for orders:', oppId);
      return Promise.resolve(); // Return to avoid errors
    }

    //save order to DB
    for (var i = 0; i < this.orderList.length; i++) {
      let order = this.orderList[i];
      order.opportunity.opportunityId = oppId;
      this.opportunityorderService.postOpportunityOrder(order).subscribe(
        response => {
          ////console.log("Create Opportunity : "+ response);
          ////console.log(response);
        },
        error => this.errorMsg = error
      );
    }

  }

  addAttachments(oppId) {
    console.log(`Adding attachments for opportunity ID: ${oppId} (${typeof oppId})`);

    // Ensure we have a valid opportunity ID
    if (!oppId || isNaN(Number(oppId)) || Number(oppId) <= 0) {
      console.error('Invalid opportunity ID for attachments:', oppId);
      return Promise.resolve(); // Return to avoid errors
    }

    //save attachments to DB
    for (var i = 0; i < this.attachmentFiles.length; i++) {
      let file = this.attachmentFiles[i];
      ////console.log(file);
      if (file.attachmentId == "1") {
        file.opportunityAttachment.opportunityId = oppId;
        this.attachmentsService.postAttachment(file).subscribe(
          response => {
            ////console.log("Create Attachment Response : "+ response);
            ////console.log(response);
          },
          error => this.errorMsg = error
        );
      }

    }
  }
  addComments(oppId) {
    console.log(`Adding comments for opportunity ID: ${oppId} (${typeof oppId})`);

    // Ensure we have a valid opportunity ID
    if (!oppId || isNaN(Number(oppId)) || Number(oppId) <= 0) {
      console.error('Invalid opportunity ID for comments:', oppId);
      return Promise.resolve(); // Return to avoid errors
    }

    // save comments to DB
    for (var i = 0; i < this.userCommentsList.length; i++) {
      let usrComment = this.userCommentsList[i];
      usrComment.opportunity.opportunityId = oppId;

      if (usrComment.commentId == -1) {

        this.commentsService.postComment(usrComment).subscribe(
          response => {
            ////console.log("Create Comment Response : "+ response);
            ////console.log(response);
          },
          error => this.errorMsg = error
        );

      }
    }

  }
  swgTabOppCollapsed = true;
  stgTabOppCollapsed = true;
  orderPopulated = false;

  onTabChange(event) {
    debugger;
    ////console.log(event);
    ////console.log(event.index);

    if (event.index == 1) {
      this.productsService.getProductsByKind('swg').subscribe((data: ProductResponse) => {
        // console.log(data);
        this.productsResponse = data;
        this.categoriesByKind = this.transformCategories(data);
      });

      if (this.opportunityTypeEle != undefined) {
        if (this.swgTabOppCollapsed) {
          this.opportunityTypeEle.nativeElement.click();
          this.swgTabOppCollapsed = false;
        }
      }


      if (this.serviceOrdersCount > 0 && this.licenseOrdersCount > 0) {

        $("#collapseOne").prop("checked", true);
        $('#collapseOne').trigger('click');
      }
      else if (this.serviceOrdersCount > 0 && this.licenseOrdersCount <= 0) {

        $("#collapseTwo").prop("checked", true);
        $('#collapseTwo').trigger('click');
      }
      else {
        $("#collapseThree").prop("checked", true);
        $('#collapseThree').trigger('click');
      }
      // if (!this.orderPopulated){
      //   this.populateOrders();
      //   this.orderPopulated = true;
      // }


      ////console.log("tab clicked......");
      //////console.log($(this).attr('id'));
      //var ordCatType="License Only";
      //var tabClicked = $(this).attr('id');
      //////console.log("tabClicked : "+tabClicked);
      //var target = $(this).attr('data-target');
      //////console.log("target : "+target);
      //$(".nav-tabs a[href='#" + target + "']").tab('show');
      // if (this.swgoptionValues[0]!==undefined)
      // {
      //   ////console.log(this.swgoptionValues[0]);
      //   if (this.swgoptionValues[0].toLowerCase().includes('service') && (this.swgoptionValues[0].toLowerCase().includes('new license')
      //       || this.swgoptionValues[0].toLowerCase().includes('reinstatement license')
      //         || this.swgoptionValues[0].toLowerCase().includes('renewal license'))){

      //     $("#collapseOne").prop("checked", true);
      //     $('#collapseOne').trigger('click');
      //   }
      //   else if (this.swgoptionValues[0].toLowerCase().includes('service') && !(this.swgoptionValues[0].toLowerCase().includes('new license')
      //       || this.swgoptionValues[0].toLowerCase().includes('reinstatement license')
      //       || this.swgoptionValues[0].toLowerCase().includes('renewal license'))){

      //     $("#collapseTwo").prop("checked", true);
      //     $('#collapseTwo').trigger('click');
      //   }
      //   else {
      //     $("#collapseThree").prop("checked", true);
      //     $('#collapseThree').trigger('click');
      //   }

      // }

    }
    if (event.index == 2) {
      this.productsService.getProductsByKind('stg').subscribe((data: ProductResponse) => {
        // console.log(data);
        this.productsResponse = data;
        this.categoriesByKind = this.transformCategories(data);
      });      if (this.stgOpportunityTypeEle != undefined) {

        if (this.stgTabOppCollapsed) {
          this.stgOpportunityTypeEle.nativeElement.click();
          this.stgTabOppCollapsed = false;
        }
      }

      // if (this.stgoptionValues[0]!==undefined )
      // {
      //   ////console.log(this.stgoptionValues[0]);
      //   if (this.stgoptionValues[0].toLowerCase().includes('service') && (this.stgoptionValues[0].toLowerCase().includes('hardware'))){

      //     $("#collapse2-1").prop("checked", true);
      //     $('#collapse2-1').trigger('click');
      //   }
      //   else if (this.stgoptionValues[0].toLowerCase().includes('service') && !(this.stgoptionValues[0].toLowerCase().includes('hardware'))){

      //     $("#collapse2-3").prop("checked", true);
      //     $('#collapse2-3').trigger('click');
      //   }
      //   else {
      //     $("#collapse2-2").prop("checked", true);
      //     $('#collapse2-2').trigger('click');
      //   }
      // }
    }
    //let myDate = "29-05-2020".replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
    //////console.log(myDate);
    //this.messageService.add({severity:'info', summary:'Tab Expanded', detail: 'Index: ' + event.index});

    //<button type="button" pButton icon="pi pi-chevron-up" (click)="openPrev()"></button>
    //<button type="button" pButton icon="pi pi-chevron-down" (click)="openNext()"></button>
    //<p-tabView [activeIndex]="index">
    //<p-tabView (onChange)="handleChange($event)">



  }

  index: number = 0;

  openNext(indx: number): void {
    //this.index = (this.index === 2) ? 0 : this.index + 1;
    ////console.log("Next Button clicked.... " + indx);
    this.index = indx;
    if (this.index == 1) {

      if (this.opportunityTypeEle != undefined) {
        if (this.swgTabOppCollapsed) {
          this.opportunityTypeEle.nativeElement.click();
          this.swgTabOppCollapsed = false;
        }
      }
    }

    if (this.index == 2) {

      if (this.stgOpportunityTypeEle != undefined) {

        if (this.stgTabOppCollapsed) {
          this.stgOpportunityTypeEle.nativeElement.click();
          this.stgTabOppCollapsed = false;
        }
      }
    }
  }

  openPrevious(indx: number): void {
    //this.index = (this.index === 0) ? 2 : this.index - 1;
    ////console.log("Previous Button clicked.... " + indx);
    this.index = indx;
  }

  handleChange(e) {
    var index = e.index;
  }



  calulateTotals() {

    $("#hardware.all").val(
        +String($("#hardware.Power").val()).replace(/,/g, '') +
        +String($("#hardware.Storage").val()).replace(/,/g, '') +
        +String($("#hardware.Z").val()).replace(/,/g, '') +
        +String($("#hardware.SDS").val()).replace(/,/g, '')
    );

    $("#hardware.all").val(parseInt($("#hardware.all").val() as string).toLocaleString());

    $("#service.all").val(
        +String($("#service.HWMA").val()).replace(/,/g, '') +
        +String($("#service.SWMA").val()).replace(/,/g, '') +
        +String($("#service.VAS").val()).replace(/,/g, '') +
        +String($("#service.Service").val()).replace(/,/g, '')
    );
    $("#service.all").val(parseInt($("#service.all").val() as string).toLocaleString());


    // $("#hardware.all").val(+$("#hardware.Power").val().replace(/,/g, '') + +$("#hardware.Storage").val().replace(/,/g, '') + +$("#hardware.Z").val().replace(/,/g, '') + +$("#hardware.SDS").val().replace(/,/g, ''));
    // $("#hardware.all").val(parseInt($("#hardware.all").val()).toLocaleString());

    // $("#service.all").val(+$("#service.HWMA").val().replace(/,/g, '') + +$("#service.SWMA").val().replace(/,/g, '') + +$("#service.VAS").val().replace(/,/g, '') + +$("#service.Service").val().replace(/,/g, ''));
    // $("#service.all").val(parseInt($("#service.all").val()).toLocaleString());

    //		  $("#total.power").val( +$("#software.Power").val().replace(/,/g,'') +  +$("#hardware.Power").val().replace(/,/g,''));
    //		  $("#total.power").val(parseInt($("#total.power").val()).toLocaleString());
    //
    //		  $("#total.z").val( +$("#software.Z").val().replace(/,/g,'') +  +$("#hardware.Z").val().replace(/,/g,''));
    //		  $("#total.z").val(parseInt($("#total.z").val()).toLocaleString());
    //
    //		  $("#total.storage").val( +$("#software.Storage").val().replace(/,/g,'') +  +$("#hardware.Storage").val().replace(/,/g,''));
    //		  $("#total.storage").val(parseInt($("#total.storage").val()).toLocaleString());
    //
    //		  $("#hardware.total").val( +$("#hardware.Power").val().replace(/,/g,'') + +$("#hardware.Z").val().replace(/,/g,'') + +$("#hardware.Storage").val().replace(/,/g,''));
    //		  $("#hardware.total").val(parseInt($("#hardware.total").val()).toLocaleString());
    //
    //		  $("#software.total").val( +$("#software.Power").val().replace(/,/g,'') + +$("#software.Z").val().replace(/,/g,'') + +$("#software.Storage").val().replace(/,/g,''));
    //		  $("#software.total").val(parseInt($("#software.total").val()).toLocaleString());
    //
    //		  $("#total.all").val( +$("#software.total").val().replace(/,/g,'') +  +$("#hardware.total").val().replace(/,/g,''));
    //		  $("#total.all").val(parseInt($("#total.all").val()).toLocaleString());




  }

  stgChangedEvent(event: any) {

    var newValue = event.target.value;//$(this).val();

    newValue = newValue.replace(/,/g, "");

    //var category = $(this).attr('id');
    // var item = $(this).attr('class');

    let category = event.target.id;
    let item = event.target.classList.value;
    ////console.log(event.target.classList.value);
    ////console.log("category " + category);
    ////console.log("item " + item);

    for (var i = 0; i < this.productList.length; i++) {
      var obj = this.productList[i];

      var orderJson = {
        "orderId": 0,
        "orderPrice": 0,
        "opportunity": { "opportunityId": '' },
        "opportunityProduct": { "productId": '' },
        "swgServiceAssetIncluded": false,
        "swgServiceAssetName": '',
        "swgServiceAssetVersion": '',
        "swgServiceAssetId": '',
        "stgServiceName": '',
        "stgServiceValue": 0
      };

      var jsonId = obj.productId;

      if (obj.productKind === "STG") {
        if (obj.productItem.item === item) {
          orderJson.orderPrice = newValue;
          this.addtoOrderList(jsonId, orderJson);

        }
      }
    }

    this.calulateTotals();
  }

  swgChangedEvent(event: any) {

    ////console.log(event);
    var orderJson = {
      "orderId": 0,
      "orderPrice": 0,
      "opportunity": { "opportunityId": '' },
      "opportunityProduct": { "productId": '' },
      "swgServiceAssetIncluded": false,
      "swgServiceAssetName": '',
      "swgServiceAssetVersion": '',
      "swgServiceAssetId": '',
      "stgServiceName": '',
      "stgServiceValue": ''
    };

    var swgServiceId = $(this).attr('id');
    var newValue = event.target.value;//$(this).val();

    newValue = newValue.replace(/,/g, "");

    let classList = event.target.classList.value;
    let arr: any[] = classList.split("-");
    let category = arr[0];
    category = category.replace("~", " ");
    let type = arr[1];
    let item = arr[2];
    //var category = $(this).closest('.card').attr('id');
    //var type = $(this).closest('.card').find(".type").attr('id');
    //var item = $(this).closest('#item').find('td').html();

    //////console.log(swgServiceId);
    //////console.log(newValue);
    ////console.log(event.target.classList.value);
    ////console.log("category " + category);
    ////console.log("type " + type);
    ////console.log("item " + item);
    ////console.log(this.orderList);
    for (var i = 0; i < this.productList.length; i++) {
      var obj = this.productList[i];

      var jsonId = obj.productId;
      if (category === 'Service' && obj.productCategory.category === category
        && obj.productKind === "SWG" && (item) !== undefined && obj.productItem.item === item) {
        ////console.log(obj);
        ////console.log('hello from inside..2');
        orderJson.orderPrice = newValue;

        orderJson.swgServiceAssetIncluded = $('#swgServiceAssetIncluded').prop("checked");
        orderJson.swgServiceAssetName = $('#swgServiceAssetName').val() as string;
        orderJson.swgServiceAssetVersion = $('#swgServiceAssetVersion').val() as string;
        orderJson.swgServiceAssetId = $('#swgServiceAssetId').val() as string;


        // orderJson.swgServiceAssetIncluded = $('#swgServiceAssetIncluded').prop("checked");
        // orderJson.swgServiceAssetName = $('#swgServiceAssetName').val();
        // orderJson.swgServiceAssetVersion = $('#swgServiceAssetVersion').val();
        // orderJson.swgServiceAssetId = $('#swgServiceAssetId').val();
        ////console.log("calling addtoorder list");
        ////console.log(this.orderList);
        this.addtoOrderList(jsonId, orderJson);

      } else if (category !== 'Service' && obj.productCategory.category === category
        && obj.productType.productType === type
        && obj.productItem.item === item) {

        orderJson.orderPrice = newValue;
        // ////console.log('hello from inside..3');
        this.addtoOrderList(jsonId, orderJson);

      }
    }
    this.calulateTotals();
  }

  addtoOrderList(jsonId, orderJson) {

    if (orderJson.orderPrice === null || orderJson.orderPrice === "") {
      orderJson.orderPrice = "0";
    }
    else if (!/^[0-9]+$/.test(orderJson.orderPrice)) {
      alert("Please only enter numeric characters");
      return
    }

    ////console.log(this.orderList);
    ////console.log("jsonId: "+jsonId);
    ////console.log("orderList.length= "+ this.orderList.length);
    if (this.orderList.length === 0) {
      orderJson.opportunityProduct.productId = jsonId;
      this.orderList.push(orderJson);
      ////console.log(this.orderList);
    } else {
      var objectPush = {};
      for (var j = 0; j < this.orderList.length; j++) {
        ////console.log(this.orderList[j].opportunityProduct.productId);
        if (this.orderList[j].opportunityProduct.productId === jsonId) {
          orderJson.opportunityProduct.productId = jsonId;
          orderJson.opportunity.opportunityId = this.orderList[j].opportunity.opportunityId;
          orderJson.orderId = this.orderList[j].orderId;
          ////console.log(this.orderList);
          objectPush = orderJson;
          this.orderList.splice(j, 1);
          ////console.log(this.orderList);
        } else {
          orderJson.opportunityProduct.productId = jsonId;
          objectPush = orderJson;
        }
      }

      this.orderList.push(objectPush);
      ////console.log(this.orderList);
    }
  }

  onUpload(event, fileUpload) {

    ////console.log(event);
    //////console.log(event.srcElement.files);
    let date = new Date();
    //var attached=document.getElementById('opportunityAttachments');
    //attached.innerHTML="";

    for (let file of event.files) {
      ////console.log(file);
      ////console.log(file.data);

      let fileAttachment: FileAttachment = {
        attachmentId: "1",
        attachmentName: file.name,
        content: file,
        contentType: file.type,
        created: (file.lastModifiedDate.getMonth() + 1) + '/' + file.lastModifiedDate.getDate() + '/' + date.getFullYear(),
        userEmail: sessionStorage.getItem("loginUserName"),
        opportunityAttachment: { opportunityId: -1 }
      };
      this.attachmentFiles.push(fileAttachment);
    }
    fileUpload.clear();
  }

  public showMsg(severity: string, summary: string, detail: string, time: number) {
    this.msgs = [{ severity: severity, summary: summary, detail: detail }];
    setTimeout(() => { this.msgs = [] }, time);
  }

  // deleteAttachment(event) {
  //   for (var kt = 0; kt < this.attachmentFiles.length; kt++) {
  //     let attachmentObj = this.attachmentFiles[kt];

  //     if (attachmentObj.attachmentId == event.srcElement.id
  //       && attachmentObj.attachmentName == event.srcElement.title) {
  //       // call delete attachment service Rest API here.....................................................................
  //       this.attachmentsService.deleteAttachment(this.editOpportunityId, attachmentObj.attachmentId).subscribe(
  //         response => {
  //           this.attachmentFiles.splice(this.attachmentFiles.indexOf(attachmentObj), 1);

  //           event.srcElement.remove();
  //           var obj = document.getElementById(event.srcElement.id);
  //           obj.remove();
  //           this.showMsg('info', 'Confirmed', 'Attachment deleted', 2000);
  //         },
  //         (error) => {
  //           this.errorMsg = error
  //           this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!', 2000);
  //         }
  //       );
  //       break;
  //     }
  //   }
  // }


  deleteAttachment(event) {
    for (let i = 0; i < this.attachmentFiles.length; i++) {
      let attachmentObj = this.attachmentFiles[i];

      if (attachmentObj.attachmentId == event.srcElement.id
          && attachmentObj.attachmentName == event.srcElement.title) {

        if (!attachmentObj.attachmentId || attachmentObj.attachmentId === "1") {
          this.attachmentFiles.splice(i, 1);
          this.showMsg('info', 'Confirmed', 'Attachment removed', 2000);
        } else {
          // Call delete API if the attachment has been submitted.
          this.attachmentsService.deleteAttachment(this.editOpportunityId, attachmentObj.attachmentId).subscribe(
            response => {
              this.attachmentFiles.splice(i, 1);
              this.showMsg('info', 'Confirmed', 'Attachment deleted', 2000);
            },
            (error) => {
              this.errorMsg = error;
              this.showMsg('warning', 'Rejected', 'Error happened while deleting!', 2000);
            }
          );
        }
        break;
      }
    }
  }


  downloadAttachment(event) {
    ////console.log(event);
    debugger
    let fileName = event.target.className;
    let fileId = event.target.id;
    for (var kt = 0; kt < this.attachmentFiles.length; kt++) {
      let attachmentObj = this.attachmentFiles[kt];
      ////console.log(attachmentObj);
      if (attachmentObj.attachmentId == fileId && fileName == attachmentObj.attachmentName) {
        this.attachmentsService.saveFile(attachmentObj.attachmentName, attachmentObj.contentType, attachmentObj.content);
        break;
      }
    }
  }


  // ---------------------------------------


  public productDialog: boolean;

  public products: OrderRow[] = [];
  public serviceOrdersCount = 0;
  public licenseOrdersCount = 0;

  public product: OrderRow;

  public selectedProducts: OrderRow[];

  public submitted: boolean;

  public editMode: boolean;
  public editIndex: number;


  selectedCategory: any;
  selectedType: any;
  selectedItem: Item;
  selectedProductId: any = null;
  ng
  selectedKind: any;
  SelectedOrderId: any;

  displayModal = false;

  productsResponse: ProductResponse;
  categoriesByKind: any[] = [];
  typesByCategory: Type[] = [];
  itemsByType: Item[] = [];


  licenseCategories: Category[] = [];
  serviceCategories: Category[] = [];

  addCategoryToGroup(category: Category, group: Category[]) {
    if (!group.find(c => c.category === category.category)) {
      group.push(category);
    }
  }

  populateDropdownGroups() {
    this.categoriesByKind = [
      { label: 'License', items: this.licenseCategories },
      { label: 'Service', items: this.serviceCategories }
    ];
  }


  openNew() {
    this.editMode = false;
    this.selectedCategory = undefined;
    this.selectedItem = undefined;
    this.selectedType = undefined;
    this.product = {};
    this.submitted = false;
    this.productDialog = true;

  }

  deleteSelectedProducts() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the selected products?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.products = this.products.filter(val => !this.selectedProducts.includes(val));
        this.selectedProducts.forEach(product => {
          this.opportunityorderService.deleteOpportunityOrder(product.orderId).subscribe(response => {
        });
        });
        this.selectedProducts = null;
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
      }
    });
  }

  editProduct(product: OrderRow, rowIndex: number) {
    this.editMode = true;
    this.editIndex = rowIndex;
    this.product = { ...product };

    // Find the category group that matches the product category
    const categoryGroup = this.categoriesByKind.find(group =>
      group.items.some(item => item.label === product.category?.category)
    );

    if (categoryGroup) {
      // Find and set the selected category from the group items
      this.selectedCategory = categoryGroup.items.find(
        item => item.label === product.category?.category
      )?.value; // Access the value property of the matched item

      if (this.selectedCategory) {
        // Set types for the matched category
        this.typesByCategory = this.selectedCategory.types;

        // Match and set the selected type by text
        this.selectedType = this.typesByCategory.find(
          type => type.productType === product.productType.productType
        );

        if (this.selectedType) {
          // Set items for the matched type
          this.itemsByType = this.selectedType.items;

          // Match and set the selected item by text
          this.selectedItem = this.itemsByType.find(
            item => item.item === product.item.item
          );
        }
      }
    }
    this.selectedProductId = product.productId;

    // Open the dialog
    this.productDialog = true;
  }


  deleteProduct(product: OrderRow, rowIndex: number) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete row: ' + rowIndex + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.products.splice(rowIndex, 1);
        this.opportunityorderService.deleteOpportunityOrder(product.orderId).subscribe(response => { });
        this.product = {};
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
      }
    });
  }

  hideDialog() {
    this.productDialog = false;
    this.submitted = false;

    this.selectedProductId == null;
    this.product.orderPrice == null
  }

  saveProduct() {
    // this.submitted = true;

    // Update the current product with the selected values
    this.product.category = this.selectedCategory;
    this.product.item = this.selectedItem;
    this.product.productType = this.selectedType;
    this.product.productId = this.selectedItem.productId;

    if (this.editMode) {
      // Access the product at the current edit index
      let editOrder: OrderRow = this.products[this.editIndex];

      // Update the fields of the product
      editOrder.category = this.selectedCategory;
      editOrder.item = this.selectedItem;
      editOrder.productType = this.selectedType;
      editOrder.orderPrice = this.product.orderPrice;
      editOrder.orderId = this.product.orderId;
      editOrder.productId = this.product.productId;

    } else {
      // Push a new copy of the product to the products array
      this.product.orderId = 0;
      this.products.push({ ...this.product });
    }

    // Trigger change detection
    this.products = [...this.products];

    // Close the product dialog and reset the product form
    this.productDialog = false;
    this.product = {};

  }



  groupedCategories: SelectItemGroup[] = [];

  private transformCategories(data: ProductResponse): SelectItemGroup[] {
    const licenseTypes: { label: string, value: Category }[] = [];
    const serviceTypes: { label: string, value: Category }[] = [];

    // Maps to keep track of categories and their types
    const categoryMap: { [key: string]: Category } = {};

    for (const kind in data) {
      for (const categoryName in data[kind]) {
        const types: Type[] = [];

        for (const typeName in data[kind][categoryName]) {
          // Create or update types for the category
          types.push({
            productType: typeName,
            items: data[kind][categoryName][typeName]
          });
        }

        // Create or update the category map
        if (!categoryMap[categoryName]) {
          categoryMap[categoryName] = {
            category: categoryName,
            types: types
          };
        } else {
          // Merge types if the category already exists
          categoryMap[categoryName].types.push(...types);
        }
      }
    }

    // Separate categories into License and Service
    Object.keys(categoryMap).forEach(categoryName => {
      const category = categoryMap[categoryName];
      if (categoryName.toLowerCase() === 'service') {
        serviceTypes.push({
          label: category.category,
          value: category
        });
      } else {
        licenseTypes.push({
          label: category.category,
          value: category
        });
      }
    });
    this.groupedCategories = [
      {
        label: 'License Categories:',
        items: licenseTypes
      },
      {
        label: 'Service Categories:',
        items: serviceTypes
      }
    ];

    return this.groupedCategories;
  }

  onCategoryChange(): void {

    this.typesByCategory = this.selectedCategory ? this.selectedCategory.types : [];
    this.itemsByType = []; // Reset items when category changes
    this.selectedType = ''; // Reset selected type
  }

  onTypeChange(): void {

    this.itemsByType = this.selectedType ? this.selectedType.items : [];
  }


  convertToOrderListFromOrdersRows() {
    this.orderList = [];
    this.products.forEach(orderRow => {
      var orderJson = {
        "orderId": orderRow.orderId,
        "orderPrice": orderRow.orderPrice,
        "opportunity": { "opportunityId": '' },
        "opportunityProduct": { "productId": orderRow.productId },
        "swgServiceAssetIncluded": false,
        "swgServiceAssetName": '',
        "swgServiceAssetVersion": '',
        "swgServiceAssetId": '',
        "stgServiceName": '',
        "stgServiceValue": ''
      };
      this.orderList.push(orderJson);
    });


  }



  handleSelectionChanged(selection: any) {
    this.selectedCategory = selection.category;
    this.selectedType = selection.type;
    this.selectedItem = selection.item;
    this.selectedProductId = selection.selectedProductId;

    // Log the values or perform further actions
    // console.log('Selected category:', this.selectedCategory);
    // console.log('Selected type:', this.selectedType);
    // console.log('Selected item:', this.selectedItem);
    // console.log('Selected product ID:', this.selectedProductId);
  }


  getKind(): string {
    if (this.hasSTG && this.hasSWG) {
      return 'ALL';
    } else if ( this.hasSWG) {
      return 'SWG';
    }  else if (this.hasSTG) {
      return 'STG';
    }
    return 'empty';
  }

  /**
   * Apply prospect data to form fields after lists are loaded
   */
  private applyProspectData() {
    if (this.prospectData) {
      console.log("Applying prospect data to form fields:", this.prospectData);

      // Set customer based on customerId from prospect
      if (this.prospectData.customerId && this.customerList) {
        const customer = this.customerList.find(c => c.customerId === this.prospectData.customerId);
        if (customer) {
          this.myGroup.controls.customerNumber.setValue(customer.customerId);
          console.log("Customer selected from prospect:", customer.customerName);
        } else {
          console.log("Customer not found for ID:", this.prospectData.customerId);
        }
      }

      // Set sales owner based on salesId from prospect
      if (this.prospectData.salesId && this.salesUsers) {
        const salesUser = this.salesUsers.find(s => s.userId === this.prospectData.salesId);
        if (salesUser) {
          this.myGroup.controls.sssOwnerName.setValue(salesUser);
          console.log("Sales owner selected from prospect:", salesUser.firstName + ' ' + salesUser.lastName);
        } else {
          console.log("Sales user not found for ID:", this.prospectData.salesId);
        }
      }

      // Set sector based on sectorId from prospect
      if (this.prospectData.sectorId && this.sectors) {
        const sector = this.sectors.find(s => s.sectorId === this.prospectData.sectorId);
        if (sector) {
          this.myGroup.controls.sector.setValue(sector.sectorId);
          console.log("Sector selected from prospect:", sector.sector);
        } else {
          console.log("Sector not found for ID:", this.prospectData.sectorId);
        }
      }

      // Trigger change detection to update UI
      this.ref.detectChanges();
    }
  }
  /**
   * Links the newly created opportunity back to the prospect
   * @param opportunityId The ID of the newly created opportunity
   */
  private linkOpportunityToProspect(opportunityId: number): void {
    if (this.prospectData && this.prospectData.prospectId) {
      console.log(`Linking opportunity ID ${opportunityId} to prospect ID ${this.prospectData.prospectId}`);

      this.prospectsService.setOpportunityToProspect(this.prospectData.prospectId, opportunityId)
        .subscribe(
          response => {
            console.log('Successfully linked opportunity to prospect:', response);
            this.showMsg('success', 'Success', 'Opportunity was linked to the prospect successfully', 3000);
          },
          error => {
            console.error('Error linking opportunity to prospect:', error);

            // Extract detailed error message
            let errorMsg = 'Failed to link opportunity to prospect';

            if (typeof error === 'string') {
              errorMsg = error;
            } else if (error.error) {
              errorMsg = typeof error.error === 'string' ? error.error : JSON.stringify(error.error);
            }

            // Check if it's a "not found" error
            const isNotFoundError = errorMsg.toLowerCase().includes('not found');

            // Show more specific message with longer duration for not found errors
            if (isNotFoundError) {
              this.showMsg(
                'error',
                'Linking Error',
                `${errorMsg}. The opportunity was created but could not be linked to the prospect.`,
                6000
              );
            } else {
              this.showMsg('error', 'Error', errorMsg, 5000);
            }
          }
        );
    }
  }
}



